import {email, date, password, required as requiredValidator, countryName} from '../units';
import validate from '../common';

const getValidations = fields => {
  const validations = {};

  fields.forEach(({name, required, type}) => {
    const validators = [];

    if (required) {
      validators.push(requiredValidator());
    }

    // eslint-disable-next-line default-case
    switch (type) {
      case 'email':
        validators.push(email());
        break;

      case 'pass':
        validators.push(password());
        break;

      case 'date':
        validators.push(date());
        break;
    }

    if (name === 'country-name') {
      const values = fields.find(i => i.name === 'country-name').value;

      validators.push(countryName({projectCountries: values}));
    }

    validations[name] = validators;
  });

  return validations;
};

export default fields => ({
  validate: validate(getValidations(fields))
});



// WEBPACK FOOTER //
// ./validators/forms/registration.js